import React, { useState, useEffect, useMemo, ReactNode } from 'react';
import { BrandingContext } from './useBrandingContext';

export interface BrandingConfig {
  platformName: string;
  logoUrl?: string;
  faviconUrl?: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor?: string;
  supportEmail?: string;
  supportPhone?: string;
  loginBgUrl?: string;
}

const DEFAULT_BRANDING: BrandingConfig = {
  platformName: 'PracticeNova',
  primaryColor: '#4CAF50',
  secondaryColor: '#2196F3',
};

export function BrandingProvider({ children }: { children: ReactNode }) {
  const [branding, setBrandingState] = useState<BrandingConfig>(DEFAULT_BRANDING);

  const setBranding = (newBranding: BrandingConfig) => {
    setBrandingState(newBranding);
    // Apply CSS variables
    document.documentElement.style.setProperty('--primary-500', newBranding.primaryColor);
    document.documentElement.style.setProperty('--secondary-500', newBranding.secondaryColor);
    if (newBranding.accentColor) {
      document.documentElement.style.setProperty('--accent', newBranding.accentColor);
    }
    document.title = newBranding.platformName;
  };

  useEffect(() => {
    // Apply default branding
    setBranding(DEFAULT_BRANDING);
  }, []);

  const value = useMemo(() => ({ branding, setBranding }), [branding]);

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}
